import { firebaseApp } from "./Config";
import { doc, getFirestore, deleteDoc } from "firebase/firestore";

export const DeleteTask = async (taskId: string) => {
	const db = getFirestore(firebaseApp);
	return await deleteDoc(doc(db, "tasks", taskId));
};
